// extracted by mini-css-extract-plugin
export default {"contain_integrantes":"competencia_contain_integrantes__B6ON2","block":"competencia_block__x37WI","contain_invitaciones":"competencia_contain_invitaciones__afcXj"};